// TableHeaders
export const headerUserTable: [string, number][] = [
  ['Name', 100],
  ['Contact Number', 150],
  ['Type', 100],
  ['Email Address', 140],
  ['Registration Date', 150],
  ['Status', 100],
  ['Action', 50],
];

export const headerErrorCodesTable: [string, number][] = [
  ['Ac Type', 50],
  ['Category', 50],
  ['Modal', 50],
  ['ErrorCode', 50],
  ['Description', 100],
  ['Troubleshooting', 100],
  ['Action', 50],
];
export const headerNotificationTable: [string, number][] = [
  ['Title', 100],
  ['Body', 200],
  ['createdAt', 90],
];

export const headerServicesTable: [string, number][] = [
  ['', 30],
  ['Service', 65],
  // ['Key', 65],s
  ['Category', 70],
  ['Status', 30],
  ['UpdatedAt', 60],
  ['CreatedAt', 60],
  ['Action', 20],
];

export const headerMaterialTable: [string, number][] = [
  ['Material Name', 25],
  ['Unit', 20],
  ['Price', 20],
  ['Status', 20],
  ['Action', 15],
];

export const headerToolTable: [string, number][] = [
  ['Tool Image', 15],
  ['Tool Name', 20],
  ['Code', 20],
  ['Description', 22],
  ['Status', 90],
  ['Action', 15],
];

export const headerTaxTable: [string, number][] = [
  ['Tax Name', 25],
  ['VAT Rate', 25],
  ['Effective From', 25],
  ['Status', 25],
];

export const headerBookingTable: [string, number][] = [
  ['Booking ID', 160],
  ['User Name', 130],
  ['Service Type', 130],
  ['Technician Name', 140],
  ['User Contact', 140],
  ['Booking Slot', 110],
  ['Status', 80],
  ['Action', 80],
];

export const headerProductTable: [string, number][] = [
  ['Product Name', 200],
  ['Brand', 140],
  ['Type', 120],
  ['Tonnage', 120],
  ['Model No', 150],
  ['Retail Price', 120],
  ['Customer Price', 150],
  ['Featured', 80],
  ['Action', 60],
];

// Product categories (UK market — added BOILER alongside the existing
// AC/HEAT_PUMP/etc. lines).
export const PRODUCT_CATEGORY_OPTIONS = [
  'AC',
  'HEAT_PUMP',
  'BOILER',
  'TOOLS',
  'SPARE_PARTS',
  'CONSUMABLES',
  'ACCESSORIES',
];

// The product "Type" dropdown is scoped per category — the old flat AC-type
// list (Split/Window/Tower/…) didn't reflect the UK market or apply to
// Heat Pump/Boiler products at all.
export const PRODUCT_TYPE_OPTIONS_BY_CATEGORY: Record<
  string,
  { value: string; label: string }[]
> = {
  AC: [
    { value: 'WALL_MOUNT', label: 'Wall Mount' },
    { value: 'CASSETTE', label: 'Cassette' },
    { value: 'DUCTED', label: 'Ducted' },
  ],
  HEAT_PUMP: [
    { value: 'OUTDOOR_UNIT', label: 'Outdoor Unit' },
    { value: 'HOT_WATER_TANK', label: 'Hot Water Tank' },
    { value: 'RADIATOR', label: 'Radiator' },
  ],
  BOILER: [
    { value: 'BOILER', label: 'Boiler' },
    { value: 'RADIATOR', label: 'Radiator' },
  ],
};

export const getProductTypeLabel = (type?: string | null) => {
  if (!type) return '';
  for (const options of Object.values(PRODUCT_TYPE_OPTIONS_BY_CATEGORY)) {
    const match = options.find((o) => o.value === type);
    if (match) return match.label;
  }
  return type;
};

export const headerLeavesTable: [string, number][] = [
  ['Technician Name', 50],
  ['Leave Type', 50],
  ['Dates', 50],
  ['Reason', 80],
  ['Status', 35],
  ['Action', 20],
];

export const headerPaymentTable: [string, number][] = [
  ['Booking ID', 70],
  ['Customer Name', 70],
  ['Customer Number', 70],
  ['Technician Name', 70],
  ['Technician Number', 70],
  // ['Technician Phone', 70],
  // ['Amount', 40],
  ['Amount', 70],
  ['Action', 30],
];

export const headerCouponTable: [string, number][] = [
  ['Image', 50],
  ['Code', 60],
  ['Name', 70],
  ['Discount', 50],
  ['Min. Value', 60],
  ['Description', 100],
  ['Expiry Date', 70],
  ['Status', 90],
  ['Action', 40],
];

export const headerAmcRequestsTable = [
  ['Booking ID', 70],
  ['User Name', 60],
  ['Request Type', 60],
  ['Inspector Name', 60],
  ['User Contact', 60],
  ['Booking Slot', 60],
  ['Status', 55],
  ['Action', 40],
];

export const headerFreeConsultancyRequestTable = [
  ['Booking ID', 80],
  ['User Name', 60],
  // ['Request Type', 60],
  // ['Inspector Name', 80],
  ['User Contact', 80],
  ['Booking Slot', 50],
  ['Status', 50],
  ['Action', 50],
];

export const headerCopperPipingRequestTable = [
  ['Enquiry ID', 80],
  ['User Name', 60],
  ['User Contact', 80],
  ['Booking Slot', 50],
  ['Schedule Date', 80],
  ['Status', 50],
  ['Updated At', 80],
];

export const headerTechnicianTable: [string, number][] = [
  // [null, 20],
  ['Name', 70],
  ['Contact Number', 60],
  ['DOB', 80],
  ['Type', 50],
  ['Experience', 50],
  ['Position', 70],
  ['Status', 40],
  // ['Status', 30],
  ['Action', 35],
];

export const headerBrandTable: [string, number][] = [
  ['Logo', 90],
  ['Brand Name',100],
  ['UpdatedAt', 130],
  ['CreatedAt', 130],
  ['Number of Errorcode', 110],
  ['Status', 90],
  ['Action', 70],
];
export const headerZonesTable = [
  [null, 10],
  ['Name', 50],
  ['Zipcodes', 200],
  ['isActive', 30],
  [null, 20],
];

export const acItems: { name: string }[] = [
  { name: 'Split AC' },
  { name: 'Vrv/vrf AC' },
  { name: 'Window AC' },
  { name: 'Ducted AC' },
  { name: 'Cassette AC' },
  { name: 'Tower AC' },
  { name: 'Concealed AC' },
];

export const SellOldACHeader: [string, number][] = [
  ['Booking ID', 70],
  ['User Name', 70],
  ['Request Type', 40],
  ['Inspector Name', 70],
  ['User Contact', 50],
  ['Booking Slot', 70],
  ['Status', 40],
  ['Action', 30],
];

// Quote-request pages (AMC / Sell Old Boiler / Expert Advice / Site Visit) —
// same column layout as Sell Old AC for table consistency.
export const QuoteRequestHeader: [string, number][] = [
  ['Booking ID', 70],
  ['User Name', 70],
  ['Request Type', 40],
  ['Technician', 70],
  ['User Contact', 50],
  ['Requested Slot', 70],
  ['Status', 40],
  ['Action', 30],
];

export const headerRequestTable: [string, number][] = [
  ['Request ID', 90],
  ['Tool Name', 60],
  ['Type', 40],
  ['Technician Name', 80],
  ['Reason', 70],
  ['Quantity', 40],
  ['Status', 60],
  // ['Action', 35],
];
export const headerCancelledTable: [string, number][] = [
  ['Booking ID', 160],
  ['User Name', 130],
  ['Service Type', 130],
  ['User Contact', 140],
  ['Reason', 110],
  ['Status', 80],
  ['Action', 80],
];
